import { Activity, EjiItem, EjiService, Item, Job, Maybe } from "../generated/nest-graphql";

// Vendor value (PartsStore.vendor) that marks a part as coming from a dealership.
export const DEALERSHIP_VENDOR = "Dealership";

// Backend contract: `noticeDealershipPartsJob` emits an Activity whose `verb`
// contains this string. It is how we detect (globally, per job) that the
// dealership parts alert was already acknowledged so the modal never shows again.
export const DEALERSHIP_PARTS_ACK_VERB = "Dealership Parts Alert Acknowledged";

const isDealershipVendor = (vendor?: Maybe<string>): boolean => vendor === DEALERSHIP_VENDOR;

// Every vendor reachable from a single EJI service item.
const ejiItemVendors = (item?: Maybe<EjiItem>): Array<Maybe<string>> => [
  item?.orderItem?.partsStore?.vendor,
  item?.partItem?.partsStore?.vendor,
  item?.jobItem?.partOrder?.store?.vendor,
];

// A job is a "dealership job" when any part item on it comes from a dealership.
export const isDealershipJob = (job?: Maybe<Job>): boolean => {
  if (!job) return false;

  const vendors: Array<Maybe<string>> = [
    job.partsStore?.vendor,
    ...(job.items ?? []).map((item: Maybe<Item>) => item?.partsStore?.vendor),
    ...(job.services ?? []).flatMap((service: Maybe<EjiService>) => (service?.items ?? []).flatMap(ejiItemVendors)),
  ];

  return vendors.some(isDealershipVendor);
};

// True once an acknowledgement Activity exists on the job's feed.
export const hasDealershipAck = (activityFeed?: Maybe<Array<Maybe<Activity>>>): boolean =>
  (activityFeed ?? []).some((activity: Maybe<Activity>) =>
    `${activity?.verb ?? ""}`.includes(DEALERSHIP_PARTS_ACK_VERB)
  );
